<script setup lang="ts">
import iconProduct from '~/assets/scss/static/huaban-5234707999@2x.png'
import iconArea from '~/assets/scss/static/huaban-5234708116@2x.png'
import iconApi from '~/assets/scss/static/huaban-5376115474@2x.png'
import iconSecurity from '~/assets/scss/static/huaban-5234709017@2x.png'
import iconService from '~/assets/scss/static/487@2x.png'

const advantages = [
  {
    title: '商品供应保障',
    desc: '拥有海量品牌授权，平台货源丰富，品类齐全，产品安全快捷。',
    icon: iconService,
  },
  {
    title: '技术实力支持',
    desc: '资深研发团队打造智能化管理系统，确保技术稳定高效。',
    icon: iconApi,
  },
  {
    title: 'API采购',
    desc: '平台提供稳定 API 接口，实现充值秒到账，专享低价。',
    icon: iconProduct,
  },
  {
    title: '安全可靠',
    desc: '采用高级加密技术，保护用户数据安全，提供可靠在线交易平台。',
    icon: iconSecurity,
  },
  {
    title: '运营售后支持',
    desc: '专业服务团队，为您处理订单与售后问题，享受无忧服务。',
    icon: iconArea,
  },
]
</script>

<template>
  <div class="merchant-advantages">
    <div
      v-for="item in advantages"
      :key="item.title"
      class="merchant-advantages__item"
    >
      <img :src="item.icon" alt="" class="merchant-advantages__icon" />
      <h3>{{ item.title }}</h3>
      <p>{{ item.desc }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.merchant-advantages {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 120px;
  row-gap: 42px;
  padding: 0 18px 10px;

  &__item {
    width: 268px;
    text-align: center;
  }

  &__icon {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto 13px;
    object-fit: contain;
  }

  h3 {
    margin: 0 0 10px;
    color: #3c4552;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.2;
  }

  p {
    max-width: 268px;
    margin: 0 auto;
    color: #819dbe;
    font-size: 13px;
    line-height: 1.72;
  }
}

@media (max-width: 900px) {
  .merchant-advantages {
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
}
</style>
